import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@spothero/ui/button';
import Price from 'common/price/Price';
import CancellationInfo from 'common/cancellation-info/CancellationInfo';
import StripePaymentRequestButton from 'user/card/StripePaymentRequestButton';

const PurchaseButton = ({
    isMonthly,
    paymentRequest,
    currencyType,
    price,
    promoCode,
    loading,
    disabled,
    validateReservationInfo,
    onReserveClick,
    showPrice,
    showAdminBorder,
    cancellationAllowed,
    isPaymentRequestAvailable,
    isApplePaySelected,
    isGooglePaySelected,
    priceBreakdownItems,
}) => {
    const isPositivePrice = price > 0;
    const buttonText = isPositivePrice ? 'Pay and Reserve' : 'Reserve Now';
    const isPaymentRequestSelected =
        (isApplePaySelected || isGooglePaySelected) && !isMonthly;
    const purchaseBtnClasses = classNames(
        'PurchaseButton',
        'Button-primary-booking-flow',
        {'admin-border-button': showAdminBorder},
        {hidden: isPaymentRequestSelected}
    );
    const prBtnClasses = classNames({
        hidden: !isPaymentRequestSelected,
    });

    return (
        <>
            {isPaymentRequestAvailable && paymentRequest && (
                <StripePaymentRequestButton
                    className={prBtnClasses}
                    paymentRequest={paymentRequest}
                    currencyType={currencyType}
                    price={price}
                    promoCode={promoCode}
                    priceBreakdownItems={priceBreakdownItems}
                    validateReservationInfo={validateReservationInfo}
                />
            )}
            <Button
                color="primary"
                className={purchaseBtnClasses}
                loading={loading}
                disabled={disabled}
                onClick={onReserveClick}
            >
                {isPositivePrice && showPrice && (
                    <>
                        <Price amount={price} currencyType={currencyType} />
                        <span className="Button-separator" />
                    </>
                )}
                {buttonText}
            </Button>
            <CancellationInfo
                className="PurchaseButton-no-cancellation"
                cancellationAllowed={cancellationAllowed}
            />
            <small className="PurchaseButton-legal">
                {isPaymentRequestSelected
                    ? 'By purchasing, you agree'
                    : `By selecting "${buttonText}" you are agreeing`}{' '}
                to SpotHero&apos;s{' '}
                <a target="_blank" href="/terms-of-use">
                    Terms and Conditions
                </a>{' '}
                and{' '}
                <a target="_blank" href="/privacy-policy">
                    Privacy Policy
                </a>
                .
            </small>
        </>
    );
};

PurchaseButton.propTypes = {
    isMonthly: PropTypes.bool,
    paymentRequest: PropTypes.object,
    currencyType: PropTypes.string,
    price: PropTypes.number.isRequired,
    promoCode: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    showPrice: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    showAdminBorder: PropTypes.bool,
    cancellationAllowed: PropTypes.string.isRequired,
    isPaymentRequestAvailable: PropTypes.bool,
    isApplePaySelected: PropTypes.bool,
    isGooglePaySelected: PropTypes.bool,
    priceBreakdownItems: PropTypes.array,
    validateReservationInfo: PropTypes.func.isRequired,
    onReserveClick: PropTypes.func.isRequired,
};

export default PurchaseButton;
